import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  editAccessRequest,
  EditAccessRequestData
} from "PFCore/services/admin/access_requests/edit_access_request";

import { accessRequestsKeys } from "./query_keys";

export const useEditAccessRequest = () => {
  const queryClient = useQueryClient();

  return useMutation<any, unknown, EditAccessRequestData>({
    mutationFn: editAccessRequest,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: accessRequestsKeys.list() });
    }
  });
};
